module.exports = __webpack_public_path__ + "static/img/icon-enter-item5.f4fdba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enter-item5.png
// module id = lB05
// module chunks = 21